import { render, staticRenderFns } from "./BancaEmaticaRichiestaScorteEdit.vue?vue&type=template&id=9e492e26"
import script from "./BancaEmaticaRichiestaScorteEdit.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaRichiestaScorteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports